<div class="page-wrapper">
    <div class="d-flex justify-content-between align-items-center mb-3 gap-3 flex-wrap">
        <div class="d-flex gap-3 align-items-center">

            <H4 style="font-size: 18px; font-weight: bolder">PERFORMANCE REPORT</H4>
        </div>



        <!-- <div class="d-flex gap-2 align-items-center">
            <span>
                Filter:
            </span>


            <div class="amc-table-action-wrapper filter">


                <div class="toggle" role="button" (click)="toggleFilterOpen()">

                    <span class="current-filter">
                        {{formatActiveFilterTitle(activePeriodFilter)}}
                    </span>

                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M0.725659 3.30012H1.97026C2.21398 3.99882 2.87945 4.50193 3.66028 4.50193C4.44112 4.50193 5.09742 4.00608 5.34535 3.31464H12.9379C13.2618 3.31464 13.5254 3.05105 13.5254 2.7271C13.5254 2.40315 13.2618 2.13956 12.9379 2.13956H5.35528C5.11576 1.43322 4.44685 0.922852 3.66028 0.922852C2.87372 0.922852 2.20176 1.43551 1.96376 2.14453H0.726041C0.407443 2.14453 0.148438 2.40392 0.148438 2.72213C0.148438 3.04035 0.407825 3.29974 0.726041 3.29974L0.725659 3.30012ZM3.66028 2.06889C4.01518 2.06889 4.3036 2.35769 4.3036 2.71258C4.3036 3.06747 4.01479 3.35628 3.66028 3.35628C3.30578 3.35628 3.01659 3.06747 3.01659 2.71258C3.01659 2.35769 3.30539 2.06889 3.66028 2.06889Z"
                            fill="black" />
                        <path
                            d="M12.9478 10.8271H11.7101C11.4721 10.1181 10.8016 9.60547 10.0135 9.60547C9.22545 9.60547 8.55807 10.1155 8.31855 10.8218H0.735974C0.412026 10.8218 0.148438 11.0854 0.148438 11.4093C0.148438 11.7333 0.412026 11.9969 0.735974 11.9969H8.32849C8.57641 12.6883 9.23806 13.1842 10.0135 13.1842C10.789 13.1842 11.4598 12.6811 11.7036 11.9824H12.9482C13.2668 11.9824 13.5258 11.723 13.5258 11.4048C13.5258 11.0865 13.2664 10.8271 12.9482 10.8271H12.9478ZM10.0132 12.0385C9.65827 12.0385 9.36985 11.7497 9.36985 11.3948C9.36985 11.0399 9.65866 10.7515 10.0132 10.7515C10.3677 10.7515 10.6569 11.0403 10.6569 11.3948C10.6569 11.7493 10.3681 12.0385 10.0132 12.0385Z"
                            fill="black" />
                        <path
                            d="M12.9478 6.48535H11.7101C11.4721 5.77633 10.8016 5.26367 10.0135 5.26367C9.22545 5.26367 8.55807 5.77366 8.31855 6.48038H0.735974C0.412026 6.48038 0.148438 6.74397 0.148438 7.06792C0.148438 7.39187 0.412026 7.65546 0.735974 7.65546H8.32849C8.57641 8.3469 9.23806 8.84275 10.0135 8.84275C10.789 8.84275 11.4598 8.33964 11.7036 7.64094H12.9482C13.2668 7.64094 13.5258 7.38155 13.5258 7.06334C13.5258 6.74512 13.2664 6.48573 12.9482 6.48573L12.9478 6.48535ZM10.0132 7.69671C9.65827 7.69671 9.36985 7.40791 9.36985 7.05302C9.36985 6.69813 9.65866 6.40971 10.0132 6.40971C10.3677 6.40971 10.6569 6.69851 10.6569 7.0534C10.6569 7.40829 10.3681 7.69671 10.0132 7.69671Z"
                            fill="black" />
                    </svg>
                </div>
                <div class="dropdown-menu px-1" [ngClass]="{show: filterOpen}">
                    <div class="dropdown-wrapper">

                        <button class="action-btn" role="button" [ngClass]="{'active': activePeriodFilter == 'TODAY'}"
                            (click)="setActiveFilter({period: 'TODAY'})">
                            Today
                        </button>

                        <button class="action-btn" role="button" [ngClass]="{'active': activePeriodFilter == 'WEEK'}"
                            (click)="setActiveFilter({period: 'WEEK'})">
                            This Week
                        </button>

                        <button class="action-btn" role="button" [ngClass]="{'active': activePeriodFilter == 'MONTH'}"
                            (click)="setActiveFilter({period: 'MONTH'})">
                            This Month
                        </button>


                        <button class="action-btn" role="button" [ngClass]="{'active': activePeriodFilter == 'YEAR'}"
                            (click)="setActiveFilter({period: 'YEAR'})">
                            This Year
                        </button>

                        <mat-form-field>
                            <mat-date-range-input [dateFilter]="dateRangeFilter" [formGroup]="rangePickerForm"
                                [rangePicker]="picker" #rangeInput>
                                <input matStartDate placeholder="Start date" formControlName="startDate">
                                <input matEndDate placeholder="End date" formControlName="endDate">
                            </mat-date-range-input>

                            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-date-range-picker #picker (closed)="onDateChange($event)"> </mat-date-range-picker>
                        </mat-form-field>

                        <app-error-message [form]="rangePickerForm" controlName="endDate"></app-error-message>


                    </div>
                </div>
            </div>
        </div> -->

    </div>

    <div class="admin-dashboard-cards">
        <div class="admin-dashboard-card admin-dashboard-card-2"
            style="background-image: url('./assets/images/dashboard-card-white-with-curves.jpg')">

            <div class="icon">
                <img src="assets/icons/stock-icon.svg">
            </div>

            <div class="content">

                <div class="top">
                    <span class="title">
                        Total Assessment Handled
                    </span>
                </div>

                @if(assessmentCardData){
                <div class="card-value">
                    <p class="text-muted">({{assessmentCardData?.totalAssessmentCount | number }})
                    <p class="value approved">
                        {{assessmentCardData?.totalAssessmentAmount | nairaCurrency }}
                    </p>
                </div>
                }
                @else {
                <span class="spinner-light"></span>
                }
            </div>
        </div>



        <div class="admin-dashboard-card admin-dashboard-card-2"
            style="background-image: url('./assets/images/dashboard-card-white-with-curves.jpg')">

            <div class="icon" style="background-color: rgb(22, 120, 212);">
                <svg id='Personal_Growth_24' width='24' height='24' viewBox='0 0 24 24'
                    xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'>
                    <rect width='24' height='24' stroke='none' fill='#fffff' opacity='0' />


                    <g transform="matrix(1 0 0 1 12 12)">
                        <path
                            style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: #ffff; fill-rule: nonzero; opacity: 1;"
                            transform=" translate(-12, -12)"
                            d="M 17 2 C 15.895430500338414 2 15 2.895430500338413 15 4 C 15 5.1045694996615865 15.895430500338414 6 17 6 C 18.104569499661586 6 19 5.1045694996615865 19 4 C 19 2.895430500338413 18.104569499661586 2 17 2 z M 6 5 L 7.7929688 6.7929688 L 3 11.585938 L 4.4140625 13 L 9.2070312 8.2070312 L 11 10 L 11 5 L 6 5 z M 15 7 C 13.895 7 13 7.895 13 9 L 13 16 L 14 16 L 14 22 L 16 22 L 16 16 L 18 16 L 18 22 L 20 22 L 20 16 L 21 16 L 21 9 C 21 7.895 20.105 7 19 7 L 15 7 z M 8 14 L 8 22 L 11 22 L 11 14 L 8 14 z M 3 18 L 3 22 L 6 22 L 6 18 L 3 18 z"
                            stroke-linecap="round" />
                    </g>
                </svg>

            </div>

            <div class="content">

                <div class="top">
                    <span class="title">
                        Top Performing Officer
                    </span>
                </div>

                @if(topPerformingOfficerCardData.officerName){
                <h5 style="font-weight: 700; text-transform: capitalize; text-wrap: nowrap;">
                    {{topPerformingOfficerCardData?.officerName }}</h5>

                <div class="card-value">
                    <span class="text-muted">({{topPerformingOfficerCardData?.totalAssessmentCount}})</span>
                    <p class="value initiated" style="font-weight: 500;">
                        {{topPerformingOfficerCardData?.totalAssessmentAmount | nairaCurrency }}
                    </p>
                </div>
                }

                @else {
                <span class="spinner-light"></span>
                }
            </div>
        </div>


        <div class="admin-dashboard-card admin-dashboard-card-2"
            style="background-image: url('./assets/images/dashboard-card-white-with-curves.jpg')">

            <div class="icon">
                <img src="assets/icons/stock-icon.svg">

            </div>

            <div class="content">

                <div class="top">
                    <span class="title">
                        Approval Rate
                    </span>
                </div>


                @if(assessmentCardData){
                <div class="card-value">
                    <p class="value failed" [ngStyle]="{color: getPercentageColor(approvalRateData?.percentage)}"
                        style="font-size: 20px;">{{approvalRateData?.percentage }}%</p>
                </div>
                }
                @else {
                <span class="spinner-light"></span>
                }

            </div>
        </div>

        <div class="admin-dashboard-card admin-dashboard-card-2"
            style="background-image: url('./assets/images/dashboard-card-white-with-curves.jpg')">

            <div class="icon">
                <img src="assets/icons/stock-icon.svg">

            </div>

            <div class="content">

                <div class="top">
                    <span class="title">
                        Fulfillment Rate
                    </span>
                </div>


                @if(fetchFulfillmentRateData){
                <div class="card-value">
                    <p class="value failed" [ngStyle]="{color: getPercentageColor(fulfillmentRateData?.percentage)}"
                        style="font-size: 20px;">{{fulfillmentRateData?.percentage }}%</p>
                </div>
                }
                @else {
                <span class="spinner-light"></span>
                }

            </div>
        </div>



    </div>


    <div class="row gx-2 gy-2">
        <div class="col-xxxl-6">
            <div class="chart-wrapper ng2-chart-wrapper">
                <div class="top">
                    <span style="color: #93A3AB; font-size: 17px; font-weight: 500;">Top Performing Officers</span>


                    <div class="filter">

                        <div class="item" [ngClass]="{'active': activePeriodFilter == 'WEEK'}"
                            (click)="setActiveFilter({period: 'WEEK'})">
                            Week
                        </div>
                        <div class="item" [ngClass]="{'active': activePeriodFilter == 'MONTH'}"
                            (click)="setActiveFilter({period: 'MONTH'})">
                            Month
                        </div>
                        <div class="item" [ngClass]="{'active': activePeriodFilter == 'YEAR'}"
                            (click)="setActiveFilter({period: 'YEAR'})">
                            Year
                        </div>

                        <div class="item date-filter" [ngClass]="{'active': activePeriodFilter == 'DATE_RANGE'}">

                            <div class="toggle" role="button" (click)="picker.open()">
                                <svg width="11" height="11" viewBox="0 0 11 11" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M8.67174 1.70312H1.67186C1.11958 1.70312 0.671875 2.10606 0.671875 2.60311V8.903C0.671875 9.40005 1.11958 9.80298 1.67186 9.80298H8.67174C9.22401 9.80298 9.67172 9.40005 9.67172 8.903V2.60311C9.67172 2.10606 9.22401 1.70312 8.67174 1.70312Z"
                                        stroke="#6B6C7E" stroke-width="0.8" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path d="M7.17188 0.803711V2.60368" stroke="#6B6C7E" stroke-width="0.8"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M3.17188 0.803711V2.60368" stroke="#6B6C7E" stroke-width="0.8"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M0.671875 4.4043H9.67172" stroke="#6B6C7E" stroke-width="0.8"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>


                                <span class="current-filter">
                                    {{formatActiveFilterTitle(activePeriodFilter)}}
                                </span>

                                <svg width="10" height="6" viewBox="0 0 10 6" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M8.67188 0.803711L4.86032 4.72335C4.83559 4.74883 4.80621 4.76904 4.77388 4.78283C4.74154 4.79661 4.70688 4.80371 4.67188 4.80371C4.63687 4.80371 4.60221 4.79661 4.56987 4.78283C4.53754 4.76904 4.50816 4.74883 4.48343 4.72335L0.671875 0.803711"
                                        stroke="#071655" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>

                            </div>

                            <mat-form-field>
                                <mat-date-range-input [dateFilter]="dateRangeFilter" [formGroup]="rangePickerForm"
                                    [rangePicker]="picker" #rangeInput>
                                    <input matStartDate placeholder="Start date" formControlName="startDate">
                                    <input matEndDate placeholder="End date" formControlName="endDate">
                                </mat-date-range-input>

                                <!-- <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle> -->
                            </mat-form-field>
                            <mat-date-range-picker #picker (closed)="onDateChange($event)"> </mat-date-range-picker>
                            <app-error-message [form]="rangePickerForm" controlName="endDate"></app-error-message>


                        </div>
                    </div>


                </div>

                <div class="graph mt-4">
                    <!-- <ngx-charts-line-chart [scheme]="lineChartColorScheme" [legend]="true" [xAxis]="showXAxis"
                        [yAxis]="showYAxis" [showXAxisLabel]="showXAxisLabel" [showYAxisLabel]="showYAxisLabel"
                        [legendTitle]="null" [autoScale]="false" [timeline]="" [results]="lineChartData"
                        [legendPosition]="legendPosition.Below">
                    </ngx-charts-line-chart> -->

                    <canvas id="charts">{{ chart }}</canvas>

                </div>
            </div>
        </div>

        <div class="col-12 mt-45">
            <div class="transaction-list">
                <div class="d-flex justify-content-between align-items-center mb-2 mt-3">
                    <h5 class="responsive-title" style="color: #2f2f2f;">ALL OFFICERS</h5>

                    <div class="d-flex gap-2 align-items-center flex-wrap" style="position: relative;">
                        <button *ngIf="transactions" class="custom-btn-primary" data-bs-toggle="dropdown"
                            (click)="attemptExport($event)">
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M10.3741 13.9445L12.568 11.7506V13.5528H13.3516V10.4186H10.2174V11.2021H12.0196L9.82562 13.3961L10.3741 13.9445ZM1.59835 14.3363C1.1674 14.3363 0.798346 14.1827 0.491195 13.8756C0.184043 13.5684 0.030729 13.1996 0.0312513 12.7692V1.79952C0.0312513 1.36857 0.184827 0.999518 0.491979 0.692367C0.79913 0.385215 1.16792 0.231901 1.59835 0.232423H12.568C12.999 0.232423 13.3681 0.385999 13.6752 0.69315C13.9824 1.0003 14.1357 1.36909 14.1351 1.79952V7.04931C13.887 6.93177 13.6324 6.83044 13.3712 6.74529C13.11 6.66014 12.8423 6.59824 12.568 6.55959V1.79952H1.59835V12.7692H6.33883C6.37801 13.0565 6.44017 13.3308 6.52531 13.5919C6.61046 13.8531 6.71154 14.1013 6.82855 14.3363H1.59835ZM1.59835 11.9857V12.7692V1.79952V6.55959V6.50082V11.9857ZM3.16545 11.2021H6.35842C6.39759 10.9279 6.45975 10.6602 6.5449 10.399C6.63005 10.1378 6.7246 9.88315 6.82855 9.63502H3.16545V11.2021ZM3.16545 8.06792H7.9451C8.363 7.67615 8.82973 7.34967 9.34531 7.08848C9.86088 6.8273 10.4128 6.651 11.0009 6.55959V6.50082H3.16545V8.06792ZM3.16545 4.93372H11.0009V3.36662H3.16545V4.93372ZM11.7845 15.9034C10.7006 15.9034 9.77652 15.5213 9.0123 14.7571C8.24808 13.9929 7.86623 13.0691 7.86675 11.9857C7.86675 10.9018 8.24886 9.97769 9.01308 9.21347C9.77731 8.44925 10.7011 8.0674 11.7845 8.06792C12.8684 8.06792 13.7925 8.45003 14.5567 9.21425C15.3209 9.97848 15.7028 10.9023 15.7022 11.9857C15.7022 13.0696 15.3201 13.9936 14.5559 14.7579C13.7917 15.5221 12.8679 15.9039 11.7845 15.9034Z"
                                    fill="white" />
                            </svg>


                            Export Data
                        </button>

                        <div class="dropdown-menu amc-table-action-select" [class.show]="dropdownOpen">
                            <div class="dropdown-wrapper">
                                <div class="action-btn" role="button" (click)="exportExcel(); $event.stopPropagation()">
                                    Excel
                                    <div class="spinner-light" *ngIf="isExportingExcel"></div>
                                </div>
                                <div class="action-btn" role="button" (click)="exportPdf(); $event.stopPropagation()">
                                    PDF
                                    <div class="spinner-light" *ngIf="isExportingPdf"></div>

                                </div>
                                <div class="action-btn" role="button" (click)="exportCsv(); $event.stopPropagation()">
                                    CSV
                                    <div class="spinner-light" *ngIf="isExportingCsv"></div>

                                </div>
                            </div>

                        </div>

                        <div class="search-container">
                            <div class="amc-search-bar" (click)="toggleShowSearch()">
                                <svg width="17" height="16" viewBox="0 0 17 16" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M15.2094 13.7386L12.9178 11.4981L12.8641 11.4164C12.7643 11.317 12.6277 11.261 12.4852 11.261C12.3426 11.261 12.2061 11.317 12.1062 11.4164C10.1587 13.2031 7.15783 13.3002 5.09373 11.6434C3.02964 9.98651 2.54284 7.08981 3.95619 4.87434C5.36953 2.65888 8.24444 1.81213 10.6743 2.89565C13.1041 3.97918 14.3349 6.65676 13.5504 9.15262C13.4939 9.33293 13.5401 9.52901 13.6716 9.66701C13.803 9.805 13.9998 9.86394 14.1878 9.82162C14.3757 9.7793 14.5263 9.64216 14.5828 9.46185C15.5207 6.49999 14.1042 3.3126 11.2498 1.9616C8.39539 0.610603 4.95962 1.50144 3.1651 4.05784C1.37058 6.61423 1.75585 10.069 4.07168 12.1872C6.38752 14.3055 9.93892 14.4515 12.4285 12.5308L14.4575 14.5146C14.6671 14.7186 15.0058 14.7186 15.2154 14.5146C15.4247 14.3077 15.4247 13.9746 15.2154 13.7678L15.2094 13.7386Z"
                                        fill="#667085" />
                                </svg> <span>Search</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="panel-div">
                    <div class="table-wrapper border-radius-full">

                        <form class="side-search-form" [formGroup]="searchForm"
                            [ngClass]="{ 'active': showSearchForm }">
                            <div class="dark-overlay" (click)="closeSearchForm()"></div>

                            <div class="side-search-form-container">
                                <div class="top">
                                    <h3 class="fw-bold">Search Filters</h3>
                                    <span class="material-symbols-outlined text-danger ms-auto" role="button"
                                        (click)="toggleShowSearch()">close</span>
                                </div>

                                <div class="filter-wrapper">

                                    <div class="message">
                                        Narrow down search results by using the options below. You must select at least
                                        one of the fields, then click Search.
                                    </div>
                                    <div class="row mt-2 g-3">
                                        <!-- Application Status -->
                                        <!-- <div class="col-12">
                                            <div class="field">
                                                <label class="form-label">Application Status</label>
                                                <select class="form-select small-option-font"
                                                    formControlName="applicationStatus">
                                                    <option value="">-- Select Status --</option>
                                                    <option value="PENDING">Pending</option>
                                                    <option value="APPROVED">Approved</option>
                                                    <option value="QUERIED">Queried</option>
                                                </select>
                                            </div>
                                        </div> -->
                                        <!-- Payment Status -->
                                        <!-- <div class="col-12">
                                            <div class="field">
                                                <label class="form-label">Payment Status</label>
                                                <select class="form-select small-option-font"
                                                    formControlName="paymentStatus">
                                                    <option value="">-- Select Status --</option>
                                                    <option value="PAID">Paid</option>
                                                    <option value="UNPAID">Unpaid</option>
                                                    <option value="PENDING">Pending</option>
                                                    <option value="FAILED">Failed</option>
                                                </select>
                                            </div>
                                        </div> -->
                                        <!-- Created By -->
                                        <!-- <div class="col-12">
                                            <div class="field">
                                                <label class="form-label">Created By</label>
                                                <ng-select [items]="[]" bindLabel="name" bindValue="id"
                                                    placeholder="-- Select Creator --" formControlName="createdBy">
                                                </ng-select>
                                            </div>
                                        </div> -->
                                        <!-- Zone -->
                                        <div class="col-12">
                                            <div class="field">
                                                <label class="form-label">Zone</label>
                                                <ng-select [items]="zones" bindLabel="name" bindValue="id"
                                                    placeholder="-- Select Zone --" formControlName="zone">
                                                </ng-select>
                                            </div>
                                        </div>
                                        <!-- Tax Office -->
                                        <!-- <div class="col-12">
                                            <div class="field">
                                                <label class="form-label">Tax Office</label>
                                                <ng-select [items]="[]" bindLabel="name" bindValue="id"
                                                    placeholder="-- Select Office --" formControlName="taxOffice">
                                                </ng-select>
                                            </div>
                                        </div> -->
                                        <!-- Officer -->
                                        <div class="col-12">
                                            <div class="field">
                                                <label class="form-label">Officers</label>
                                                <ng-select [items]="officers" [multiple]="true" bindLabel="displayName"
                                                    bindValue="id" placeholder="-- Select Officer --"
                                                    formControlName="officerIds" [readonly]="!officers">
                                                </ng-select>
                                            </div>
                                        </div>

                                        <!-- Date -->
                                        <div class="col-12">
                                            <div class="field">
                                                <label class="form-label">Officer Name</label>
                                                <input type="text" class="form-control" formControlName="officerName" />
                                            </div>
                                        </div>


                                        <div class="col-12">
                                            <div class="field">
                                                <label>Assessment Count Condition</label>
                                                <select class="form-select small-option-font"
                                                    (change)="onConditionChange()"
                                                    formControlName="assessmentCountCondition">
                                                    <option value="">Select Condition</option>
                                                    <option value="Equals To"> Equals To</option>
                                                    <option value="Greater Than"> Greater Than</option>
                                                    <option value="Lesser Than"> Lesser Than</option>
                                                    <option value="Between">Between</option>
                                                </select>
                                            </div>
                                        </div>

                                        <div class="col-12 field"
                                            *ngIf="searchForm.get('assessmentCountCondition').value == 'Equals To'">
                                            <label>Count</label>
                                            <input type="text" separator appOnlyNumber
                                                class="form-control small-option-font" formControlName='amount' />
                                        </div>
                                        <div class="col-12 field"
                                            *ngIf="searchForm.get('assessmentCountCondition').value == 'Greater Than'">
                                            <label>Greater Than</label>
                                            <input type="text" separator appOnlyNumber
                                                class="form-control small-option-font" formControlName='greaterThan' />
                                        </div>
                                        <div class="col-12 field"
                                            *ngIf="searchForm.get('assessmentCountCondition').value == 'Lesser Than'">
                                            <label>Lesser Than</label>
                                            <input type="text" separator appOnlyNumber
                                                class="form-control small-option-font" formControlName='lesserThan' />
                                        </div>
                                        <div class="col-12 d-flex flex-wrap align-items-center gap-4"
                                            *ngIf="searchForm.get('assessmentCountCondition').value == 'Between'">
                                            <div class="field" style="flex: 1;">
                                                <label>Minimum</label>
                                                <input type="text" separator appOnlyNumber
                                                    class="form-control small-option-font"
                                                    formControlName='greaterThanOrEquals' />
                                            </div>
                                            <span class="mt-3"> - </span>
                                            <div class=" field" style="flex: 1;">
                                                <label>Maximum</label>
                                                <input type="text" separator appOnlyNumber
                                                    class="form-control small-option-font"
                                                    formControlName='lesserThanOrEquals' />
                                            </div>
                                        </div>

                                        <div class="col-md-12">
                                            <div class="field">
                                                <label>Date Range</label>
                                                <div class="item date-filter">
                                                    <div class="toggle" role="button"
                                                        (click)="searchFilterDateRangePicker.open()">
                                                        <svg width="11" height="11" viewBox="0 0 11 11" fill="none"
                                                            xmlns="http://www.w3.org/2000/svg">
                                                            <path
                                                                d="M8.67174 1.70312H1.67186C1.11958 1.70312 0.671875 2.10606 0.671875 2.60311V8.903C0.671875 9.40005 1.11958 9.80298 1.67186 9.80298H8.67174C9.22401 9.80298 9.67172 9.40005 9.67172 8.903V2.60311C9.67172 2.10606 9.22401 1.70312 8.67174 1.70312Z"
                                                                stroke="#6B6C7E" stroke-width="0.8"
                                                                stroke-linecap="round" stroke-linejoin="round" />
                                                            <path d="M7.17188 0.803711V2.60368" stroke="#6B6C7E"
                                                                stroke-width="0.8" stroke-linecap="round"
                                                                stroke-linejoin="round" />
                                                            <path d="M3.17188 0.803711V2.60368" stroke="#6B6C7E"
                                                                stroke-width="0.8" stroke-linecap="round"
                                                                stroke-linejoin="round" />
                                                            <path d="M0.671875 4.4043H9.67172" stroke="#6B6C7E"
                                                                stroke-width="0.8" stroke-linecap="round"
                                                                stroke-linejoin="round" />
                                                        </svg>
                                                        <span class="current-filter">
                                                            {{formatSearchFormDateRangeTitle()}}
                                                        </span>

                                                        <div class="ms-auto me-2">
                                                            <svg 
                                                            *ngIf="startDate?.value"
                                                            xmlns="http://www.w3.org/2000/svg" 
                                                            height="17"
                                                            (click)="clearDatePickerDate(); $event.stopPropagation()"
                                                                width="17" viewBox="0 0 24 24" fill="currentColor">
                                                                <path
                                                                    d="M18.3 5.71a1 1 0 0 0-1.41 0L12 10.59 7.11 5.7A1 1 0 0 0 5.7 7.11L10.59 12l-4.88 4.89a1 1 0 1 0 1.41 1.41L12 13.41l4.89 4.88a1 1 0 0 0 1.41-1.41L13.41 12l4.88-4.89a1 1 0 0 0 .01-1.4z" />
                                                            </svg>

                                                            <svg width="10" height="6" viewBox="0 0 10 6" fill="none"
                                                                class=" ms-2" xmlns="http://www.w3.org/2000/svg">
                                                                <path
                                                                    d="M8.67188 0.803711L4.86032 4.72335C4.83559 4.74883 4.80621 4.76904 4.77388 4.78283C4.74154 4.79661 4.70688 4.80371 4.67188 4.80371C4.63687 4.80371 4.60221 4.79661 4.56987 4.78283C4.53754 4.76904 4.50816 4.74883 4.48343 4.72335L0.671875 0.803711"
                                                                    stroke="#071655" stroke-linecap="round"
                                                                    stroke-linejoin="round" />
                                                            </svg>
                                                        </div>
                                                    </div>
                                                    <mat-form-field>
                                                        <mat-date-range-input [dateFilter]="dateRangeFilter"
                                                            [formGroup]="searchForm"
                                                            [rangePicker]="searchFilterDateRangePicker" #rangeInput>
                                                            <input matStartDate placeholder="Start date"
                                                                formControlName="startDate">
                                                            <input matEndDate placeholder="End date"
                                                                formControlName="endDate">
                                                        </mat-date-range-input>
                                                        <!-- <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle> -->
                                                    </mat-form-field>
                                                    <mat-date-range-picker #searchFilterDateRangePicker>
                                                    </mat-date-range-picker>
                                                    <app-error-message [form]="searchForm"
                                                        controlName="endDate"></app-error-message>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- Search Button -->
                                        <div class="col-12 d-flex align-items-end">
                                            <button class="custom-btn-primary w-100"
                                                [disabled]="appliedFilterCount <= 0" (click)="fetchReportTable()">
                                                Apply Search {{ appliedFilterCount > 0 ? 'Filter' + (appliedFilterCount
                                                > 1 ? 's' : '') + ' (' + appliedFilterCount + ')' : 'Filter' }}
                                            </button>
                                        </div>
                                        <!-- Clear & Close -->
                                        <div class="actions d-flex justify-content-end">
                                            <span class="clear-all-btn" role="button"
                                                (click)="clearSearchFilters()">Clear
                                                all filters</span>
                                        </div>


                                    </div>
                                </div>
                            </div>
                        </form>


                        <table class="role-table amc-table" appAutoDataLabel>
                            <thead class="amc-table-heading">
                                <tr>
                                    <th>S/N</th>
                                    <th>Officer</th>
                                    <th>Tax Office</th>
                                    <th>Total Assessments</th>
                                    <th>Approved Assessments</th>
                                    <th>Pending Assessments</th>
                                    <th>Paid Assessments</th>
                                    <th>Total Assessment Amount</th>
                                    <th>Amount Paid</th>
                                    <th>Amount Unpaid</th>
                                    <th>Approval Rate (%)</th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr *ngFor="let transaction of transactions; let i = index">
                                    <td>
                                        {{ i + (pageSize * (currentPage - 1)) + 1 }}
                                    </td>
                                    <td>
                                        {{ transaction?.officerName | titlecase }}
                                    </td>
                                    <td>
                                        {{ transaction?.zoneName | titlecase }}
                                    </td>
                                    <td>
                                        {{ transaction?.totalAssessmentCount | number }}
                                    </td>
                                    <td>
                                        {{ transaction?.approvedAssessmentCount | number }}
                                    </td>
                                    <td>
                                        {{ transaction?.pendingAssessmentCount | number }}
                                    </td>
                                    <td>
                                        {{ transaction?.paidAssessmentCount | number }}
                                    </td>
                                    <td>
                                        {{ transaction?.totalAmount | nairaCurrency }}
                                    </td>
                                    <td>
                                        {{ transaction?.totalAmountPaid | nairaCurrency }}
                                    </td>
                                    <td>
                                        {{ transaction?.totalAmountUnpaid | nairaCurrency }}
                                    </td>
                                    <td [ngClass]="{
                                        'text-success': transaction?.approvalRate > 75,
                                        'text-warning': transaction?.approvalRate > 49 && transaction?.approvalRate <= 75,
                                        'text-danger': transaction?.approvalRate <= 49
                                      }">
                                        {{ transaction?.approvalRate }}%
                                    </td>
                                </tr>
                            </tbody>
                        </table>


                        @if(errorFetchingTransactionHistory) {
                        <p class="text-center text-danger p-3">Error Fetching Data</p>
                        }

                        @if(isSearching) {
                        <div class="p-4">
                            <app-bounce-loader></app-bounce-loader>
                        </div>
                        }

                        @if(searchedtransactionsNotFound) {
                        <p class="text-center text-danger p-3">No officers with fit this search filter...</p>
                        }
                    </div>
                </div>

                <div class="d-flex justify-content-between align-items-center mt-2 flex-wrap">
                    <div class="d-flex align-items-center me-4">
                        <div>Rows per page:</div>
                        <div class="mx-2">
                            <select class="form-control px-6 text-center" style="width: auto; min-width: 40px"
                                [(ngModel)]="selectedLimit" (change)="updateLimit()">
                                <option [value]="10">10</option>
                                <option [value]="20">20</option>
                                <option [value]="30">30</option>
                                <option [value]="40">40</option>
                                <option [value]="50">50</option>
                            </select>
                        </div>
                    </div>

                    <div class="pagination-container">
                        <ngb-pagination *ngIf="!isSearching && count > 0" [(page)]="currentPage"
                            (pageChange)="onPageChange($event)" [maxSize]="5" [pageSize]="pageSize"
                            [collectionSize]="count" [boundaryLinks]="true" [directionLinks]="true" [rotate]="true"
                            class="pagination justify-content-center my-3">
                        </ngb-pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>










</div>

<!-- <app-bounce-loader></app-bounce-loader> -->